"use client";

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, ChevronDown } from "lucide-react";
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { addExperienceSchema } from "@/utils/schema/addExperienceSchema";
import {
  useCreateExperienceMutation,
  useCreateSimulationConfigurationMutation,
  useGetCampaignsQuery,
  useGetSimulationTemplatesQuery,
  useGetTenantsQuery,
} from "@/store/slices/apiSlice";
import { initAlertMsg, SHOW_MESSAGE } from "@/lib/constant/constant";
import AlertMsg from "../../common/AlertMsg";
import { focusFirstEditable } from "@/utils/focusFirstEditable";

const dummyCampaigns = [
  "Workplace Safety Training",
  "Cyber Awareness Q2",
  "Onboarding Simulation",
];

const dummyTemplates = [
  {
    id: "template-001",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-002",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-003",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-004",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-005",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
  {
    id: "template-006",
    name: "Template Name",
    description:
      "Template Description: Dummy Text | Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    duration: "25 minutes",
    difficulty: "Medium",
  },
];

const AddExperienceDialog = ({
  open,
  onClose,
  tenantName = "",
  campaignId = "",
  deepLink,
  templateId,
  // defaultCampaign = "Workplace Safety Training",
  defaultCampaign = "",
  onSuccess,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [alertMsg, setAlertMsg] = useState(initAlertMsg);

  const { data: campaignList, isLoading, error } = useGetCampaignsQuery();
  const campaignsList = campaignList?.response?.data;

  const { data: tenantList, isLoading: isTenantLoading } = useGetTenantsQuery();
  const tenantsList = tenantList?.response?.data;

  const {
    data: templateList,
    isLoading: isTemplateLoading,
    error: templateError,
  } = useGetSimulationTemplatesQuery();
  const templatesList = templateList?.response?.data;

  const [createExperience] = useCreateExperienceMutation();
  const [createSimulationConfiguration] =
    useCreateSimulationConfigurationMutation();

  const [step, setStep] = useState(1);

  const [isSaving, setIsSaving] = useState(false);
  // const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    templateId || "",
  );

  useEffect(() => {
    if (templateId) {
      setSelectedTemplateId(templateId);
    } else {
      setSelectedTemplateId("");
    }
  }, [templateId]);

  const form = useForm({
    resolver: zodResolver(addExperienceSchema),
    defaultValues: {
      tenant: tenantName,
      campaign: defaultCampaign,
      name: "",
      description: "",
    },
  });

  const shouldDisableTenantCampaignSelects = Boolean(
    tenantName && defaultCampaign && campaignId,
  );

  const selectedTenantName = form.watch("tenant");

  const selectedTenantForCampaign = tenantsList?.find(
    (tenant) => tenant.orgName === selectedTenantName,
  );

  const filteredCampaignsList = shouldDisableTenantCampaignSelects
    ? campaignsList || []
    : selectedTenantForCampaign?._id
      ? campaignsList?.filter(
          (campaign) => campaign.tenantId === selectedTenantForCampaign._id,
        ) || []
      : [];

  useEffect(() => {
    form.setValue("tenant", tenantName || "");
    form.setValue("campaign", defaultCampaign || "");
  }, [tenantName, defaultCampaign, form]);

  const handleClose = () => {
    // navigate("/tenants");
    form.reset();
    // setStep(1);
    // setSelectedTemplateId("");
    if (!templateId) {
    setSelectedTemplateId("");
}
    onClose?.();
    // if (from?.pathname) {
    //   navigate(from.pathname, {
    //     state: from.state,
    //   });
    // }
  };
  const handleClosePopup = () => {
    form.reset();
    setSelectedTemplateId("");
    onClose?.();
  };
  // console.log("SElected template ID", selectedTemplateId)
  const onSubmit = async () => {
    if (templateId) {
      handleStartEditing();
      return;
    }
    setStep(2);
    // setIsSaving(true);

    // try {
    //   const payload = {
    //     // simulationTemplateId: selectedTemplateId,
    //     simulationTemplateId,
    //     campaignId,
    //     tenant: values.tenant,
    //     campaign: values.campaign,
    //     name: values.name,
    //     description: values.description,
    //   };

    //   // const response = await fakeApiCall(payload);
    //   const res = await createExperience(payload);
    //   if (res?.data?.response?.statusEnum === 1) {
    //     setStep(2);
    //   }
    // } finally {
    //   setIsSaving(false);
    // }
  };
  const handleAlertClose = () => {
    setAlertMsg({
      open: false,
      label: "",
      msg: "",
      isError: false,
      isLoading: false,
      btnText: "",
      canClose: false,
    });
  };
  const handleStartEditing = async () => {
    if (!selectedTemplateId) {
      console.error("Please select a template first");
      return;
    }

    setIsSaving(true);

    try {
      const values = form.getValues();

      const selectedCampaign = campaignsList?.find(
        (campaign) => campaign.campaignName === values.campaign,
      );

      const selectedTenant = tenantsList?.find(
        (tenant) => tenant.orgName === values.tenant,
      );

      const experiencePayload = {
        tenantId: selectedTenant?._id,
        campaignId: selectedCampaign?._id || campaignId,
        simulationTemplateId: selectedTemplateId,
        name: values.name,
        description: values.description,
      };

      // console.log("Create Experience Payload:", experiencePayload);

      const experienceRes = await createExperience(experiencePayload).unwrap();

      const createdExperience =
        experienceRes?.response?.data ||
        experienceRes?.data?.response?.data ||
        experienceRes?.data ||
        experienceRes;

      // console.log("Created Experience:", createdExperience);

      const experienceId = createdExperience?._id || createdExperience?.id;

      if (!experienceId) {
        console.error("Experience ID missing:", createdExperience);
        return;
      }

      const finalTenantId = createdExperience?.tenantId || selectedTenant?._id;

      const finalCampaignId =
        createdExperience?.campaignId || selectedCampaign?._id || campaignId;

      const configurationPayload = {
        tenantId: finalTenantId,
        campaignId: finalCampaignId,
        experienceId,
        simulationTemplateId: selectedTemplateId,
        name: values.name,
      };

      // console.log("Create Configuration Payload:", configurationPayload);

      const configRes =
        await createSimulationConfiguration(configurationPayload).unwrap();

      const createdConfiguration =
        configRes?.response?.data ||
        configRes?.data?.response?.data ||
        configRes?.data ||
        configRes;

      // console.log("Created Configuration:", createdConfiguration);

      const configurationId =
        createdConfiguration?._id ||
        createdConfiguration?.id ||
        createdConfiguration?.configurationId;

      if (!configurationId) {
        console.error("Configuration ID missing:", createdConfiguration);
        setAlertMsg({
          open: true,
          label: SHOW_MESSAGE?.CREATE_SIMULATION_CONFIGURATION_FAILED_HEADING,
          msg: createdConfiguration || "Simulation configuration ID is missing",
          isError: true,
          btnText: "Close",
          canClose: false,
        });
        return;
      }

      onSuccess?.({
        response: {
          data: {
            ...createdExperience,
            setupStep: 4,
            configurationId,
            experienceId,
            tenantId: finalTenantId,
            campaignId: finalCampaignId,
          },
        },
      });

      handleClose();
      navigate("/tenants/campaigns/experiences/edit", {
        state: {
          configurationId,
          experienceId,
          deepLink,
          campaignId: finalCampaignId,
          tenantId: finalTenantId,
          simulationTemplateId: selectedTemplateId,
          experienceName: values.name,
          tenantName: values.tenant,
          defaultCampaign: values.campaign,
        },
      });
    } catch (error) {
      console.error("Start editing failed:", error);

      const errorMessage =
        error?.data?.response?.message ??
        error?.data?.message ??
        error?.message ??
        "Something went wrong";

      if (errorMessage.toLowerCase().includes("duplicate key error")) {
        setAlertMsg({
          open: true,
          label: SHOW_MESSAGE?.DUPLICATE_EXPERIENCE_NAME_MSG,
          msg: errorMessage,
          isError: true,
          btnText: "Close",
          canClose: false,
        });
      } else {
        setAlertMsg({
          open: true,
          label: SHOW_MESSAGE?.CREATE_SIMULATION_CONFIGURATION_FAILED_HEADING,
          msg: errorMessage,
          isError: true,
          btnText: "Close",
          canClose: false,
        });
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        className={`w-[calc(100vw-32px)] ${step == 1 ? "max-w-3xl" : "max-w-7xl"} max-h-[92vh] overflow-y-auto border bg-brand-10 border-brand-11 px-5
    py-8 text-neutral-100 shadow-2xl sm:px-8 lg:px-16 lg:py-12`}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        // Prevent auto-focus when dialog opens
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          focusFirstEditable(e.currentTarget);
        }}
      >
        {step === 1 ? (
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit, (errors) => {
                // console.log("Validation Errors =====", errors);
              })}
              // onSubmit={form.handleSubmit(handleSaveExperienceDetails)}
            >
              <DialogHeader className="mb-8 text-left">
                <DialogTitle className="text-2xl font-bold text-[#67D8FF]">
                  Add Experience Details
                </DialogTitle>
                <DialogDescription className="sr-only">
                  Add experience details
                </DialogDescription>
              </DialogHeader>

              <div className="space-y-5">
                <FormField
                  control={form.control}
                  name="tenant"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-sm font-bold text-neutral-100">
                        Tenant
                      </FormLabel>

                      <FormControl>
                        <TenantSelect
                          value={field.value}
                          options={tenantsList || []}
                          onChange={(value) => {
                            field.onChange(value);
                            form.setValue("campaign", "");
                          }}
                          disabled={shouldDisableTenantCampaignSelects}
                        />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="campaign"
                  rules={{ required: "Campaign is required" }}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-sm font-bold text-neutral-100">
                        Campaign
                      </FormLabel>

                      <FormControl>
                        <CampaignSelect
                          value={field.value}
                          options={filteredCampaignsList}
                          onChange={field.onChange}
                          disabled={
                            shouldDisableTenantCampaignSelects ||
                            !selectedTenantForCampaign?._id
                          }
                        />
                      </FormControl>

                      <FormMessage className="text-sm text-red-500" />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="name"
                  rules={{ required: "Experience name is required" }}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-sm font-bold text-neutral-100">
                        Experience Name
                      </FormLabel>

                      <FormControl>
                        <Input
                          placeholder="Enter experience name (e.g. Cyber Escape Intro)"
                          className="form-dark-input"
                          {...field}
                        />
                      </FormControl>

                      <FormMessage className="text-sm text-red-500" />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="description"
                  rules={{
                    maxLength: {
                      value: 125,
                      message: "Description cannot exceed 125 characters",
                    },
                  }}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-sm font-bold text-neutral-100">
                        Description
                      </FormLabel>

                      <p className="text-sm text-neutral-100/60">
                        Enter a short description of this campaign
                      </p>

                      <FormControl>
                        <textarea
                          placeholder="Enter a short description (max 125 characters)"
                          maxLength={125}
                          className="
                            min-h-[110px]
                            w-full
                            rounded-md
                            border
                            border-[#14708A]
                            bg-[#151515]
                            px-4
                            py-3
                            text-sm
                            text-neutral-100
                            outline-none
                            placeholder:text-neutral-100/50
                            focus:border-brand-15
                          "
                          {...field}
                        />
                      </FormControl>

                      <FormMessage className="text-sm text-red-500" />
                    </FormItem>
                  )}
                />
              </div>

              <DialogFooter className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-end">
                <Button
                  type="button"
                  variant="neutral"
                  onClick={handleClosePopup}
                  disabled={isSaving}
                  //   className="h-11 w-full border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100 sm:w-auto"
                  className="px-8"
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSaving}
                  className="h-11 w-full bg-brand-21 px-8 font-bold text-neutral-100 hover:bg-brand-22 sm:w-auto"
                >
                  {isSaving ? "Saving..." : "Save & Next"}
                </Button>
              </DialogFooter>
            </form>
          </Form>
        ) : (
          <>
            <DialogHeader className="mb-4 text-left">
              <DialogTitle className="text-2xl font-bold text-[#67D8FF]">
                Select Template
              </DialogTitle>
              <DialogDescription className="sr-only">
                Select experience template
              </DialogDescription>
            </DialogHeader>

            <div className="max-h-[650px] overflow-y-auto pr-2">
              <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                {templatesList.map((template) => (
                  <TemplateCard
                    key={template.id}
                    template={template}
                    selected={selectedTemplateId === template.id}
                    onClick={() => setSelectedTemplateId(template.id)}
                  />
                ))}
              </div>
            </div>

            <DialogFooter className="mt-4 flex flex-col gap-3 sm:flex-row sm:justify-end">
              <Button
                type="button"
                variant="neutral"
                onClick={() => setStep(1)}
                disabled={isSaving}
                // className="h-11 w-full border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100 sm:w-auto"
                className="px-8"
              >
                Back
              </Button>
              {/* <Button
                type="button"
                variant="neutral"
                onClick={() => form.reset()}
                disabled={isLoading || form.formState.isSubmitting}
                className="px-8"
              >
                Clear
              </Button> */}

              <Button
                type="button"
                onClick={handleStartEditing}
                disabled={isSaving || !selectedTemplateId}
                className="h-11 w-full bg-brand-21 px-8 font-bold text-neutral-100 hover:bg-brand-22 sm:w-auto"
              >
                {isSaving ? "Starting..." : "Start Editing"}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
      <AlertMsg
        label={alertMsg.label}
        msg={alertMsg.msg}
        open={alertMsg.open}
        onClose={handleAlertClose}
        confirmAction={handleAlertClose}
        isLoading={false}
        isError={alertMsg.isError}
        canClose={alertMsg.canClose}
        confirmationBtnText={alertMsg.btnText}
      />
    </Dialog>
  );
};

const TenantSelect = ({ value, options, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          setOpen((prev) => !prev);
        }}
        className={`flex h-12 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-left text-sm font-bold text-neutral-100 outline-none ${
          disabled ? "cursor-not-allowed opacity-70" : ""
        }`}
      >
        <span>{value || "Select tenant"}</span>

        <ChevronDown className="h-6 w-6 text-[#67D8FF]" />
      </button>

      {open && !disabled && (
        <div className="absolute z-30 mt-1 max-h-60 w-full overflow-y-auto rounded-md border border-[#14708A] bg-brand-100 shadow-lg">
          {Array.isArray(options) && options.length > 0 ? (
            options.map((option) => (
              <button
                key={option._id}
                type="button"
                onClick={() => {
                  onChange(option.orgName);
                  setOpen(false);
                }}
                className="block w-full px-4 py-3 text-left text-sm font-semibold text-neutral-100 hover:bg-brand-19"
              >
                {option.orgName}
              </button>
            ))
          ) : (
            <div className="px-4 py-3 text-sm text-neutral-100/60">
              No tenants found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const CampaignSelect = ({ value, options, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          setOpen((prev) => !prev);
        }}
        className={`flex h-12 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-left text-sm font-bold text-neutral-100 outline-none ${
          disabled ? "cursor-not-allowed opacity-70" : ""
        }`}
      >
        <span>{value || "Select campaign"}</span>
        <ChevronDown className="h-6 w-6 text-[#67D8FF]" />
      </button>

      {open && !disabled && (
        <div className="absolute z-30 mt-1 max-h-60 w-full overflow-y-auto rounded-md border border-[#14708A] bg-brand-100 shadow-lg">
          {Array.isArray(options) && options.length > 0 ? (
            options.map((option) => (
              <button
                key={option._id}
                type="button"
                onClick={() => {
                  onChange(option.campaignName);
                  setOpen(false);
                }}
                className="block w-full px-4 py-3 text-left text-sm font-semibold text-neutral-100 hover:bg-brand-19"
              >
                {option.campaignName}
              </button>
            ))
          ) : (
            <div className="px-4 py-3 text-sm text-neutral-100/60">
              No campaigns found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const TemplateCard = ({ template, selected, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        rounded-md
        border
        bg-[#1B416B]
        p-3
        text-left
        transition
        hover:border-brand-15
        ${selected ? "border-brand-15" : "border-brand-17"}
      `}
    >
      <div className="mb-4 flex h-[130px] items-center justify-center rounded bg-[#10243A]">
        <Box className="h-14 w-14 text-neutral-100/35" />
      </div>

      <h3 className="mb-2 text-sm font-bold text-neutral-100">
        {template.name}
      </h3>

      <p className="mb-4 text-xs leading-relaxed text-neutral-100">
        {template.description}
      </p>

      <div className="flex flex-wrap gap-2">
        <span className="rounded bg-[#355D88] px-3 py-1 text-[10px] text-neutral-100/90">
          Approx Duration: {template.duration}
        </span>

        <span className="rounded bg-[#355D88] px-3 py-1 text-[10px] text-neutral-100/90">
          Difficulty: {template.difficulty}
        </span>
      </div>
    </button>
  );
};

export default AddExperienceDialog;
